import type { ReactNode } from "react"
import { Link } from "@/components/Link/Link.component"
import type { ArticleTeaserModel } from "@/services/api/content/models/article-teaser-model.types"

type ArticleTeaserLinkProps = {
  readonly children: ReactNode
  readonly className?: string
  readonly position?: string
  readonly testId?: string
  readonly article: ArticleTeaserModel
}

export function ArticleTeaserLink({
  children,
  className,
  testId,
  article,
  position,
}: ArticleTeaserLinkProps) {
  const { id, targetUrl, section, supportingImage, recommendationId } =
    article.content

  return (
    <Link
      className={className}
      href={targetUrl}
      position={position}
      testId={testId}
      trackingModel={{
        contentId: id.toString(),
        contentSource: null,
        contentType: "article-teaser",
        recommendationId: recommendationId ?? null,
      }}
      webviewArticle={{
        id: id.toString(),
        imageUrl: supportingImage?.aspectRatio3By2,
        sectionTitle: section?.name,
      }}
    >
      {children}
    </Link>
  )
}
